import React from "react"
import Staff from "../../images/staff-augmentation.svg"
import DeliveryTeam from "../../images/delivery-team.svg"
import { Link } from "gatsby"

const OurServices = () => {
  return (
    <section className="container mx-auto px-6 py-8">
      <h3 className="text-5xl pb-8 font-normal leading-tight text-center">
        <span className="text-secondary block font-bold">Our</span> Services
      </h3>
      <div className="flex flex-col md:flex-row items-center pb-8">
        <div className="w-full md:w-1/2 pb-8">
          <img src={Staff} alt="Staff Augmentation" className="mx-auto" />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
          <h4 className="text-4xl pb-8 font-medium">
            <span className="text-secondary block">Staff</span> Augmentation
          </h4>
          <h5 className="pb-8 font-medium">
            Scale up delivery capacity with dedicated professionals
          </h5>
          <p className="pb-8">
            From Avalith we offer you support at times where you need it most,
            with complete support for all your projects.
          </p>
          <Link
            to="/services/staff-augmentation"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Let's grow
          </Link>
        </div>
      </div>
      {/* Delivery Team */}
      <div className="flex flex-col md:flex-row-reverse items-center pb-8">
        <div className="w-full md:w-1/2 pb-8">
          <img
            src={DeliveryTeam}
            alt="Delivery Team"
            width="380"
            className="mx-auto"
          />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
          <h4 className="text-4xl pb-8 font-medium">
            <span className="text-secondary block">Delivery</span> Team
          </h4>
          <h5 className="pb-8 font-medium">
            We achieve effective project development, respecting cost and time
            constraints
          </h5>
          <p className="pb-8">
            We dedicate ourselves to train the ideal team for your project,
            according to the experience of each member of our staff. We have
            well-trained professionals in various areas.
          </p>
          <Link
            to="/services/delivery-team"
            className="mx-auto lg:mr-5 lg:mx-0 mb-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Your team
          </Link>
        </div>
      </div>
    </section>
  )
}

export default OurServices
